import {Brand} from '@vio/core/src/brand/types'
import {getCheckoutHost, getSearchHost} from '@vio/core/src/brand/utils'

const SEARCH_RESULTS_PATH = '/Hotel/Search'
const PAYMENT_PATH = '/checkout'
export const BOOKING_MANAGEMENT_PATH = '/bookings'

export const getSearchResultsUrl = (brand: Brand) => {
  return new URL(
    SEARCH_RESULTS_PATH,
    getSearchHost({brand, appEnv: process.env.NEXT_PUBLIC_ENV})
  ).href
}

export const getPaymentPageUrl = (brand: Brand): string => {
  return new URL(
    PAYMENT_PATH,
    getCheckoutHost({brand, appEnv: process.env.NEXT_PUBLIC_ENV})
  ).href
}
